/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 空席待ち情報。空席待ち詳細情報取得要否=trueの場合のみ返却する
 */
export interface JourneyElementWaitlist {
  /**
   * 空席待ちエントリー状況。セグメントステータスおよびOnload Statusから判断した空席待ちのステータス<br> notWaitlisted：空席待ちなし<br> waitlisted：空席待ち中<br> waitlistClosed：空席待ち受付終了
   */
  status: JourneyElementWaitlist.StatusEnum;
  /**
   * アップグレード空席待ちである。空席待ち中または空席待ち受付終了の場合のみ返却する<br> 当該journeyElementと同一の搭乗者およびセグメントに紐づき、当該journeyElementよりも下位のキャビンクラスであるjourneyElementが存在する場合、true
   */
  isUpgradeWaitlisted?: boolean;
  /**
   * 空席待ち総数。空席待ち中の場合のみ返却する
   */
  totalNumber?: number;
  /**
   * 空席待ち順位。空席待ち中の場合のみ返却する
   */
  rank?: number;
}
export namespace JourneyElementWaitlist {
  export type StatusEnum = 'notWaitlisted' | 'waitlisted' | 'waitlistClosed';
  export const StatusEnum = {
    NotWaitlisted: 'notWaitlisted' as StatusEnum,
    Waitlisted: 'waitlisted' as StatusEnum,
    WaitlistClosed: 'waitlistClosed' as StatusEnum,
  };
}
